import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class HmacServiceService {
  generateHmac(url: string, secretKey: string): string {
    return CryptoJS.HmacSHA256(url, secretKey).toString(CryptoJS.enc.Hex);
  }
}
